import * as React from 'react';

export const useMountEffect = (
  fn: () => Promise<void> | void | (() => void),
) => {
  React.useEffect(() => {
    const result = fn();
    return typeof result === 'function' ? result : undefined;
  }, []); // eslint-disable-line
};
